import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";
import Icon, { IconName } from "../Icon";
import { Text } from "../";

const Base = styled.div<{ selected?: boolean }>`
  transition-duration: 0.2s;
  transition-property: background-color, border;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${select.space(2)};
  box-sizing: border-box;
  color: ${p =>
    p.selected ? select.color(["primary", 5]) : select.color(["grey", 5])};
  background-color: ${p =>
    p.selected ? select.color(["primary", 0], p) : "transparent"};
  border: 1px solid
    ${p =>
      p.selected
        ? select.color(["primary", 5], p)
        : select.color(["grey", 5], p)};
  border-radius: ${select.radius("normal")};
  cursor: ${p => (p.selected ? "default" : "pointer")};

  & > div {
    color: ${p =>
      p.selected
        ? select.color(["primary", 5], p)
        : select.color(["grey", 5], p)};
  }

  &:hover {
    background-color: ${select.color(["primary", 0])};
    border: 1px solid ${select.color(["primary", 5])};
    color: ${select.color(["primary", 5])};

    & > div {
      color: ${select.color(["primary", 5])};
    }
  }
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  icon?: IconName;
  text?: string;
  onClick?: () => void;
  selected?: boolean;
};

function IconBox(
  { style, className, icon, text, onClick, selected }: Props,
  ref: any
) {
  return (
    <Base
      selected={selected}
      ref={ref}
      style={style}
      className={className}
      onClick={onClick}
    >
      <Icon
        size={20}
        c="inherit"
        name={icon as any}
        style={{ marginRight: 8 }}
      />
      <Text uppercase c="inherit">
        {text}
      </Text>
    </Base>
  );
}

export default React.forwardRef(IconBox);
